interface StatusBadgeProps {
  label: string;
  tone?: "info" | "success" | "warning" | "scheduled" | "danger" | "neutral";
  className?: string;
}

const TONE_CLASS: Record<NonNullable<StatusBadgeProps["tone"]>, string> = {
  info: "bg-brand-100 text-brand-800 dark:bg-brand-500/25 dark:text-brand-100",
  success: "bg-success-100 text-success-800 dark:bg-success-900/35 dark:text-success-100",
  warning: "bg-warning-100 text-warning-800 dark:bg-warning-900/35 dark:text-warning-100",
  scheduled: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-200",
  danger: "bg-danger-100 text-danger-800 dark:bg-danger-900/35 dark:text-danger-100",
  neutral: "bg-gray-200 text-ink dark:bg-surface-hover",
};

const StatusBadge = ({ label, tone = "neutral", className = "" }: StatusBadgeProps): JSX.Element => {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${TONE_CLASS[tone]} ${className}`.trim()}
    >
      {label}
    </span>
  );
};

export default StatusBadge;